import { Component, Input, Output, EventEmitter } from '@angular/core';
import { FileItem } from '../../components/file-transfer-v2/file-transfer-v2.component';

@Component({
  selector: 'app-selected-files-panel',
  templateUrl: './selected-files-panel.component.html',
  styleUrls: ['./selected-files-panel.component.scss']
})
export class SelectedFilesPanelComponent {
  @Input() selectedFiles: FileItem[] = [];
  @Input() title: string = 'Files selected to be shared';
  
  @Output() fileCheckboxChange = new EventEmitter<{file: FileItem, checked: boolean}>();
  @Output() shareSelectedFiles = new EventEmitter<void>();
  
  /**
   * Handles checkbox change for a file in the selected files panel
   */
  onFileCheckboxChange(file: FileItem, checked: boolean): void {
    this.fileCheckboxChange.emit({file, checked});
  }
  
  /**
   * Triggers sharing of selected files
   */
  onShareSelected(): void {
    this.shareSelectedFiles.emit();
  }
} 